var map = {
	"./css/home-style.css": 21473,
	"./icons/Setting-industry.png": 59681,
	"./icons/additional-settings.png": 57216,
	"./icons/answer-email.png": 73097,
	"./icons/applicant-hire-ratio.png": 16341,
	"./icons/average-call.png": 57467,
	"./icons/average-time-hire.png": 19685,
	"./icons/avg-candidates.png": 57439,
	"./icons/avg-interviews-offer.png": 2366,
	"./icons/bar.png": 54787,
	"./icons/calendar.png": 43611,
	"./icons/call-connect.png": 78466,
	"./icons/candidate-16.png": 40632,
	"./icons/candidate-24.png": 44453,
	"./icons/candidate-white.png": 55614,
	"./icons/candidates-hvr.png": 72140,
	"./icons/candidates-hvr1.jpg": 7818,
	"./icons/candidates.png": 8381,
	"./icons/candidates1.jpg": 96033,
	"./icons/ceo.png": 96561,
	"./icons/chart.png": 75395,
	"./icons/customer-hover.png": 88763,
	"./icons/customer-white.png": 91927,
	"./icons/customer.png": 42812,
	"./icons/dashboard-hover.png": 54567,
	"./icons/dashboard-white.png": 56685,
	"./icons/dashboard.png": 15609,
	"./icons/domain-icon.png": 93926,
	"./icons/domain-working-in-lap.png": 12844,
	"./icons/duplicate.png": 51734,
	"./icons/effectiveness.png": 89527,
	"./icons/email-settings.png": 74503,
	"./icons/email-tools.png": 14466,
	"./icons/envelope-with-pencil.png": 1146,
	"./icons/excel-24.png": 8402,
	"./icons/existing-templates.png": 69210,
	"./icons/facebook-icon.png": 14705,
	"./icons/failure.png": 58761,
	"./icons/faq.png": 41643,
	"./icons/folder.png": 5720,
	"./icons/handshake.png": 94092,
	"./icons/hire-source.png": 92077,
	"./icons/import-file.png": 64104,
	"./icons/interview (1).png": 27153,
	"./icons/interview-white.png": 70223,
	"./icons/job-bag.png": 77919,
	"./icons/job-hover.png": 73150,
	"./icons/job-suitcase.png": 22136,
	"./icons/job.png": 134,
	"./icons/jobprofile-white.png": 53544,
	"./icons/kpi-icon.png": 87838,
	"./icons/mail-icon.png": 69086,
	"./icons/mail.png": 32752,
	"./icons/meeting-16.png": 24014,
	"./icons/meeting-blue.png": 98829,
	"./icons/meeting-white.png": 18397,
	"./icons/minus.png": 72316,
	"./icons/myinbox-hover.png": 24372,
	"./icons/myinbox-white.png": 39570,
	"./icons/myinbox.png": 56327,
	"./icons/offers-accepted.png": 12085,
	"./icons/offers-denied.png": 3677,
	"./icons/other-reports-icon.png": 85895,
	"./icons/pink.gif": 2792,
	"./icons/productivity.png": 40955,
	"./icons/quality-of-hire.png": 59102,
	"./icons/questionnaire.png": 17319,
	"./icons/rate.png": 51752,
	"./icons/recruit-32.png": 4474,
	"./icons/recruit-white.png": 73428,
	"./icons/recruiter-performance.png": 61201,
	"./icons/register.png": 67029,
	"./icons/resume.png": 6144,
	"./icons/scope-icon.png": 31503,
	"./icons/settings-border.png": 76264,
	"./icons/settings-gears.png": 12322,
	"./icons/settings-tools-white.png": 58382,
	"./icons/share-16.png": 67880,
	"./icons/share.png": 69296,
	"./icons/sigma.png": 98096,
	"./icons/sms-icon.png": 95177,
	"./icons/sourcing-channel.png": 44896,
	"./icons/statistics-white.png": 28452,
	"./icons/support.png": 69399,
	"./icons/talentidentified-hire-ratio.png": 71025,
	"./icons/technology-skills-icons.png": 7676,
	"./icons/template-management.png": 7132,
	"./icons/time-zone-icon.jpg": 86105,
	"./icons/tool-demo-white.png": 84645,
	"./icons/tooldemo-white.png": 37568,
	"./icons/tools-settings.png": 70563,
	"./icons/tools.png": 7832,
	"./icons/twitter-icon.png": 61113,
	"./icons/user-silhouette-hover.png": 67590,
	"./icons/user-silhouette.png": 86217,
	"./icons/user.png": 40856,
	"./icons/user1.png": 83494,
	"./icons/user2.png": 72173,
	"./icons/user3.png": 26319,
	"./icons/user4.png": 48736,
	"./icons/user5.png": 48049,
	"./icons/user6.png": 18396,
	"./icons/value-16.png": 61570,
	"./icons/value-blue.png": 14609,
	"./icons/value-white.png": 34434,
	"./icons/web-design-hover.png": 25501,
	"./icons/web-design.png": 15806,
	"./icons/working-with-laptop-16.png": 99219,
	"./icons/working-with-laptop-24.png": 31179,
	"./icons/working-with-laptop-hover.png": 95031,
	"./icons/working-with-laptop.png": 36856,
	"./images/Pdf.jpg": 48038,
	"./images/Service-3.jpg": 88603,
	"./images/banner1.jpg": 82464,
	"./images/banner2.jpg": 72523,
	"./images/banner3.jpg": 91726,
	"./images/checked.png": 86298,
	"./images/coins.png": 44397,
	"./images/file2.png": 84490,
	"./images/fixed-cost.png": 52455,
	"./images/flexibility.png": 2042,
	"./images/hidden-costs.png": 22646,
	"./images/innerpages_banner1.jpg": 44765,
	"./images/landing-page-background01.png": 35737,
	"./images/loader.svg": 60355,
	"./images/microsoftexcel.jpg": 54933,
	"./images/our-values.jpg": 15129,
	"./images/saaa-cloud-model.png": 7064,
	"./images/talent-turbo-logo1.png": 57406,
	"./images/talentturbo.png": 44240,
	"./images/talentturbo1.png": 66773,
	"./images/talentturbo10.png": 3988,
	"./images/technologies.png": 80540,
	"./images/trial-period.png": 83636,
	"./images/word.jpg": 10597,
	"./logo.png": 66949,
	"./socialmedia/facebook-icon1.png": 86121,
	"./socialmedia/facebook-icon2.png": 43544,
	"./socialmedia/linkedin-icon1.png": 18264,
	"./socialmedia/linkedin-icon2.png": 67653,
	"./socialmedia/twitter-icon1.png": 53162,
	"./socialmedia/twitter-icon2.png": 75726,
	"./videos/tool-demo/AddCandidate.mp4": 92543,
	"./videos/tool-demo/AddJob.mp4": 80666,
	"./videos/tool-demo/CandidateList.mp4": 94622,
	"./videos/tool-demo/JobList.mp4": 79272
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;